import { render, staticRenderFns } from "./SettingsScoreTemplates.vue?vue&type=template&id=2aeef7c8"
import script from "./SettingsScoreTemplates.vue?vue&type=script&lang=js"
export * from "./SettingsScoreTemplates.vue?vue&type=script&lang=js"
import style0 from "./SettingsScoreTemplates.vue?vue&type=style&index=0&id=2aeef7c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports